import { z } from "zod";

export const zPaperMemberMatchRequest = z.object({
	memberCode: z.string().min(1, "会員番号を入力してください"),
	name: z.string().min(1, "名前を入力してください"),
});
